(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8c83"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8c83"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("j6RVe", function(module, exports) {

$parcel$export(module.exports, "initTabsBlock", function () { return $de9867a63973b7f0$export$7d642003a3fd854e; });

var $1MMdM = parcelRequire("1MMdM");
var $de9867a63973b7f0$var$initialized = new WeakMap();
function $de9867a63973b7f0$export$7d642003a3fd854e(blockSelector) {
    var onClick = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, root = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : document;
    var prefix = blockSelector.slice(1);
    (0, $1MMdM.findBlocks)(root, blockSelector).forEach(function(block) {
        var activate = function activate(index) {
            navItems.forEach(function(item, i) {
                item.classList.toggle('is-active', i === index);
                var btn = item.querySelector(".".concat(prefix, "__nav-btn"));
                if (btn) {
                    btn.setAttribute('aria-selected', String(i === index));
                    btn.setAttribute('tabindex', i === index ? '0' : '-1');
                }
            });
            panels.forEach(function(panel, i) {
                panel.classList.toggle('is-active', i === index);
                panel.setAttribute('aria-hidden', String(i !== index));
            });
            if (triggerLabel) {
                var btn = navItems[index].querySelector(".".concat(prefix, "__nav-btn"));
                triggerLabel.textContent = btn.textContent.trim();
            }
        };
        var closeDropdown = function closeDropdown() {
            if (!trigger) return;
            trigger.setAttribute('aria-expanded', 'false');
            navList.classList.remove('is-open');
        };
        if ($de9867a63973b7f0$var$initialized.has(block)) return;
        var navItems = block.querySelectorAll(".".concat(prefix, "__nav-item"));
        var panels = block.querySelectorAll(".".concat(prefix, "__panel"));
        var trigger = block.querySelector(".".concat(prefix, "__nav-trigger"));
        var triggerLabel = block.querySelector(".".concat(prefix, "__nav-trigger-label"));
        var navList = block.querySelector(".".concat(prefix, "__nav"));
        navItems.forEach(function(item, index) {
            var btn = item.querySelector(".".concat(prefix, "__nav-btn"));
            btn.addEventListener('click', function() {
                activate(index);
                closeDropdown();
            });
            btn.addEventListener('keydown', function(e) {
                var _navItems_newIndex_querySelector;
                var newIndex;
                if (e.key === 'ArrowRight' || e.key === 'ArrowDown') newIndex = (index + 1) % navItems.length;
                else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') newIndex = (index - 1 + navItems.length) % navItems.length;
                else if (e.key === 'Home') newIndex = 0;
                else if (e.key === 'End') newIndex = navItems.length - 1;
                else return;
                e.preventDefault();
                activate(newIndex);
                (_navItems_newIndex_querySelector = navItems[newIndex].querySelector(".".concat(prefix, "__nav-btn"))) === null || _navItems_newIndex_querySelector === void 0 ? void 0 : _navItems_newIndex_querySelector.focus();
            });
            if (!onClick) item.addEventListener('mouseenter', function() {
                if (block.ownerDocument.defaultView.innerWidth > 768) activate(index);
            });
        });
        if (trigger) {
            trigger.addEventListener('click', function() {
                var isOpen = trigger.getAttribute('aria-expanded') === 'true';
                trigger.setAttribute('aria-expanded', String(!isOpen));
                navList.classList.toggle('is-open', !isOpen);
            });
            block.ownerDocument.addEventListener('click', function(e) {
                if (!block.contains(e.target)) closeDropdown();
            });
        }
        $de9867a63973b7f0$var$initialized.set(block, true);
    });
}

});
parcelRegister("1MMdM", function(module, exports) {

$parcel$export(module.exports, "findBlocks", function () { return $14cfaddf7b657fa6$export$ee06a5357e65c7df; });
$parcel$export(module.exports, "isBlockEditor", function () { return $14cfaddf7b657fa6$export$22780c2770c6471f; });
$parcel$export(module.exports, "bootBlock", function () { return $14cfaddf7b657fa6$export$3ba659c19d85cb2f; });

var $2Xzd1 = parcelRequire("2Xzd1");
function $14cfaddf7b657fa6$var$findAll(root, selector) {
    var found = Array.from(root.querySelectorAll(selector));
    return root.matches && root.matches(selector) ? [
        root
    ].concat((0, $2Xzd1._)(found)) : found;
}
function $14cfaddf7b657fa6$export$ee06a5357e65c7df(root, selector) {
    return $14cfaddf7b657fa6$var$findAll(root, selector);
}
function $14cfaddf7b657fa6$export$22780c2770c6471f() {
    return Boolean(window.acf) && document.body.classList.contains('block-editor-page');
}
function $14cfaddf7b657fa6$export$3ba659c19d85cb2f(slug, init) {
    if ($14cfaddf7b657fa6$export$22780c2770c6471f()) {
        window.acf.addAction("render_block_preview/type=".concat(slug), function($block) {
            init($block.get(0), {
                isEditor: true
            });
        });
        return;
    }
    var run = function() {
        return init(document, {
            isEditor: false
        });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
}

});
parcelRegister("2Xzd1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $227c6742e0ff6f82$export$71511d61b312f219; });

var $gUOYc = parcelRequire("gUOYc");

var $Q6yVl = parcelRequire("Q6yVl");

var $4S8xA = parcelRequire("4S8xA");

var $ihB7G = parcelRequire("ihB7G");
function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $gUOYc._)(arr) || (0, $Q6yVl._)(arr) || (0, $ihB7G._)(arr) || (0, $4S8xA._)();
}

});
parcelRegister("gUOYc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c50969dc1df61e8b$export$71511d61b312f219; });

var $gNF1f = parcelRequire("gNF1f");
function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $gNF1f._)(arr);
}

});
parcelRegister("gNF1f", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c3b10a83b523f372$export$71511d61b312f219; });
function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("Q6yVl", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $09c9f293d010c0e1$export$71511d61b312f219; });
function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("4S8xA", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $38c2d4931cb7a7c4$export$71511d61b312f219; });
function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("ihB7G", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d4f69c5c6c4654b1$export$71511d61b312f219; });

var $gNF1f = parcelRequire("gNF1f");
function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $gNF1f._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $gNF1f._)(o, minLen);
}

});





var $j6RVe = parcelRequire("j6RVe");

var $1MMdM = parcelRequire("1MMdM");
(0, $1MMdM.bootBlock)('features-tabs', function(root) {
    (0, $j6RVe.initTabsBlock)('.features-tabs', false, root);
});

})();
//# sourceMappingURL=script.js.map
